<pre class="code-example"><button type="button" class="copy-button" (click)="copyCode()" [class.copied]="copied()">
		<lucide-icon [name]="copied() ? 'Check' : 'Copy'" [size]="20"></lucide-icon>
	</button><code>{{ code }}</code></pre>
